import { algoliasearch } from 'algoliasearch';
import aa from 'search-insights';
import { ALGOLIA_CONFIG } from '@libTs/cms.globals';

const { appId, searchKey, indexName } = ALGOLIA_CONFIG;

export const searchClient = algoliasearch(appId, searchKey);
export { indexName };

export type AlgoliaHighlight = {
  value: string;
  matchLevel: 'full' | 'partial' | 'none';
};

export type AlgoliaHit = {
  objectID: string;
  title: string;
  url: string;
  type: string;
  sectionHandle: string;
  image?: string;
  seoTitle: string;
  seoKeywords: string;
  seoDescription: string;
  postDate: string;
  date?: string;
  dateTimestamp?: number;
  _highlightResult: {
    title?: AlgoliaHighlight;
    seoDescription?: AlgoliaHighlight;
    seoKeywords?: AlgoliaHighlight;
  };
};

export const BASE_SEARCH_PARAMS = {
  highlightPreTag: '<em>',
  highlightPostTag: '</em>',
  removeWordsIfNoResults: 'allOptional' as const,
};

let insightsReady = false;
export const setupInsights = (): void => {
  if (insightsReady) return;
  aa('init', { appId, apiKey: searchKey, useCookie: true });
  insightsReady = true;
};

export const trackClick = (params: {
  eventName: string;
  queryID: string;
  objectID: string;
  position: number;
}): void => {
  aa('clickedObjectIDsAfterSearch', {
    userToken: aa('getUserToken')?.toString(),
    eventName: params.eventName,
    index: indexName,
    queryID: params.queryID,
    objectIDs: [params.objectID],
    positions: [params.position],
  });
};

// One-time cleanup of the removed recent-search history
try {
  localStorage.removeItem('sks-recent-searches');
} catch {
  /* ignore disabled storage */
}
